module.exports = __webpack_public_path__ + "static/media/preview.6ebd08bf.png";